import type {Design} from "../_types/Design";

import {PatternFillOptions} from "../_types/PatternFillOptions";
import type {Size} from "../_types/Size";

export const getObjectCountFromDesign = (sceneSize: Size, design: Design): number => {

    const { fill } = design.properties;

    if (fill.mode === "frame") {
        return 1;
    }

    if (fill.mode === "pattern") {
        return getObjectCountFromPatternFillMode(sceneSize, fill.options!);
    }

    throw new Error("Unreachable");
};

const getObjectCountFromPatternFillMode = (
    sceneSize: Size,
    options: PatternFillOptions
): number => {

    const diagonal = Math.sqrt(Math.pow(sceneSize.width, 2) + Math.pow(sceneSize.height, 2));

    const spacing = {x: options.spacing.x * diagonal, y: options.spacing.y * diagonal};

    const patternCellWidth = options.width * spacing.x;
    const patternCellHeight = options.height * spacing.y;

    const drawOffset = {
        x: Math.abs(((sceneSize.width / 2) % patternCellWidth) - patternCellWidth),
        y: Math.abs(((sceneSize.height / 2) % patternCellHeight) - patternCellHeight)
    };

    const columns = Math.ceil((sceneSize.width + drawOffset.x * 2) / patternCellWidth) + 1;
    const rows = Math.ceil((sceneSize.height + drawOffset.y * 2) / patternCellHeight) + 1;

    return rows * columns * options.pattern.length;
};